import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewEncapsulation,
    ElementRef
} from "@angular/core";
import { FnTimepickerService } from "./../services/timepicker.service";
import { FNTimeData } from "./../services/timepicker.model";
import { FnTimePickerComponent } from "./fn-time-picker.component";
import { isNotNull, isNull } from "../../../util/check";

@Component({
    selector: "fn-time-picker2",
    templateUrl: "fn-time-picker.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class FnTimePicker2Component extends FnTimePickerComponent {
    @Input() minuteDiff = 1;
    @Input() startAtIndex = 0;
    @Input() startindex: number;
    @Output() callback: EventEmitter<FNTimeData> = new EventEmitter();

    private timeObj: FNTimeData;
    private totalIndex = 1440;
    constructor(
        protected override timePickerSvcs: FnTimepickerService,
        protected override  elemeRef: ElementRef
    ) {
        super(timePickerSvcs, elemeRef);
    }

    /**
     * Method to set default data when component is loaded
     */
    protected override setDefaultData() {
        this.isMilitryTime = isNull(this.isMilitryTime)
            ? this.timePickerSvcs.isMilitaryTime
            : this.isMilitryTime;
        if (this.isMilitryTime) {
            this.placeholder = "hh:mm";
            this.validValueRegex = this.timePickerSvcs.regexMap.regexMilitary;
        } else {
            this.placeholder = "hh:mm a";
            this.validValueRegex = this.timePickerSvcs.regexMap.regex12ap;
        }
        this.mainItemArray = this.getTimeStrArray();
        this.uiItemArray = this.mainItemArray;
        this.index = this.getIndex(this.index);
        this.activeItem = this.index;
        if (this.index > -1) {
            this.searchTerm = this.getActiveTime();
            this.filterTime(null);
            this.emitTimeChangeEvent(null);
        }
    }

    private getTimeStrArray() {
        this.totalIndex = Number(this.totalIndex / this.minuteDiff);
        const timeArray = this.timePickerSvcs.getTimeArray(
            { 'startTime': 0 },
            1440,
            "",
            this.minuteDiff,
            this.isMilitryTime
        );
        return timeArray
            .slice(this.startAtIndex, this.totalIndex)
            .concat(timeArray.slice(0, this.startAtIndex));
    }

    protected override setValueByIndex(value: number) {
        if (value > -1) {
            this.searchTerm = this.mainItemArray[value];
        } else {
            this.index = -2;
            this.searchTerm = "";
        }
        this.setErrorMessage();
        this.activeItem = this.index;
    }

    protected override filterTime(event: Event) {
        this.activeItem = -1;
        if (this.isSearchItem(event)) {
            this.timeObj = this.timePickerSvcs.getSelectedIndexForTime(
                this.searchTerm
            );
            if (
                this.timeObj.minute > -1 &&
                this.timeObj.minute % this.minuteDiff === 0
            ) {
                const minIndex = this.timeObj.minute / this.minuteDiff;
                this.timeObj.index = this.getIndex(minIndex);
                this.index = this.timeObj.index;
                this.activeItem = this.index;
            }
        } else {
            this.activeItem = -2;
            this.index = -1;
            this.timeObj = null;
        }
        if (isNotNull(event)) {
            this.setItemScroll(true);
        }
    }

    private getIndex(minIndex: number) {
        if (isNotNull(minIndex) && minIndex > -1) {
            if (minIndex > 1440) {
                minIndex = minIndex - 1440;
            } else if (isNotNull(this.startindex) && minIndex <= this.startindex) {
                this.isNextDay = true;
            } else {
                this.isNextDay = false;
            }
            return minIndex < this.startAtIndex
                ? this.totalIndex - this.startAtIndex
                : minIndex - this.startAtIndex;
        }
        return -1;
    }

    override onItemClick() {
        this.searchTerm = this.getActiveTime();
        this.filterTime(null);
        this.closeDropDown();
    }

    protected override emitTimeChangeEvent(value: number) {
        this.searchTerm = this.getActiveTime();
        this.callback.emit(this.timeObj);
    }

    protected override setActiveTimeOnArrowKey(isKeyup: boolean) {
        this.openDropDown();
        this.calActiveValue(isKeyup);
        this.searchTerm = this.getActiveTime();
        this.filterTime(null);
    }

    override closeDropDown(): void {
        super.closeDropDown();
        this.searchTerm =
            this.index === this.activeItem ? this.getActiveTime() : this.searchTerm;
        this.emitTimeChangeEvent(null);
    }

    override openDropDown() {
        super.openDropDown();
        setTimeout(() => {
            this.setItemScroll();
        }, 0);
    }

    // override
    protected override setDropDownFromRange() { }
}
